@if (apiFragment$ | async; as record) {
  <dt class="sh-description-list__term">{{ labels.get('Regimen') }}</dt>
  <dd class="sh-description-list__details">{{ record.metadata.Dynamic.DossierPublicity?.Regimen || '-' }}</dd>
  @if (shouldShowMotivation(record)) {
    <dt class="sh-description-list__term">{{ labels.get('Motivations') }}</dt>
    <dd class="sh-description-list__details">
      @if (record.metadata.Dynamic.DossierPublicity?.Motivations?.Motivation?.length > 0) {
        <ul class="edp-unstyled-list">
          @for (motivation of record.metadata.Dynamic.DossierPublicity?.Motivations?.Motivation; track motivation) {
            <li>{{motivation}}</li>
          }
        </ul>
      } @else {
        -
      }
    </dd>
    <dt class="sh-description-list__term">{{ labels.get('Date') }}</dt>
    <dd class="sh-description-list__details">{{ record.metadata.Dynamic.DossierPublicity?.Date | readableDate }}</dd>
  }
}

